import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import appSettings from "../mixins/config/appSettings";

Vue.use(Vuetify);

import en from "../locale/en.ts"
import nl from "../locale/nl.ts"
import de from "../locale/de.ts"
import fr from "../locale/fr.ts"
import pl from "../locale/pl.ts"
import ro from "@/locale/ro.ts";
import tr from "@/locale/tr.ts";
import es from "@/locale/es.ts";

export const defaultLanguage = 'en'

export default new Vuetify({
    lang : {
        locales: {
            en, nl, fr, de, pl, ro, tr, es
        },
        current : defaultLanguage,
    },
    theme : {
        options: {
            customProperties: true,
        },
        themes : {
            light : {
                primary: appSettings.data().appSettings.colors.primary,
                secondary: appSettings.data().appSettings.colors.secondary, //OUR DARKER COLOR
                accent: appSettings.data().appSettings.colors.accent
            }
        },
    }
});
